import { getStateFull, doAction, dispatch } from '../../core/redux/store';
import { AT } from '../../actions/actionTypes';
import * as MyKeysApiCustomers from '../../core/apis/mykeys/customers';

import { getColumns } from '../../components/customersPage/columns';
import * as DT from '../datatable';
import * as Devices from '../devices';
import * as DTHelper from '../datatable/utils';

import {
  State,
  SearchPageFetchPL,
  SearchPageSuccessPL,
  SearchPageRes,
  Customer,
  FilterCriteria,
  SearchPageErrorPL,
} from './model';
import { ErrorDataResponse } from '../../core/apis/mykeys/exceptions';
import { SortCriteria } from '../datatable';
import {
  buildCriteraList,
  updateCriteria,
  clearCriterionByType,
} from '../../core/apis/mykeys/searchCriteria';
import { getTotalsFromSelectedKeys, msgSearchError } from './utils';
import { criterionNames, SearchCriteriaDto } from '../../interfaces';
import { FeedbackAddPL } from '../../models';
import Logger from '../../libs/logger';   import { LogArea } from '../../libs/logger/const';

export const getState = (): State => getStateFull().customersState;

export const changeTablePage = (pageNumber: number) =>
  dispatch(DT.changeTablePage(AT.CUSTOMERS.TABLE_PAGE_CHANGE, pageNumber));

export const changeTableSizePage = (pageSize: number) =>
  dispatch(
    DT.changeTableSizePage(AT.CUSTOMERS.TABLE_PAGESIZE_CHANGE, pageSize)
  );

export const changeTableSorting = (sort: SortCriteria[]) =>
  dispatch(DT.changeTableSorting(AT.CUSTOMERS.SORT_CRITERIA_UPADATED, sort));

export const updateTableItemSelection = (item: Customer) =>
  dispatch(DT.updateTableItemSelection(AT.CUSTOMERS.TABLE_SELECT_ITEM, item));

export const updateTableSelectAll = () => {
  dispatch({ type: AT.CUSTOMERS.TABLE_TOGGLE_ALL });
};

export const isTableItemSelected: DT.IsItemSelectedType<Customer> = (o) =>
  DTHelper.isTableItemSelected(o, getState().selection);

export const clearSelection = () =>
  dispatch({ type: AT.CUSTOMERS.CLEAR_SELECTION });

export const updateFilterCriteria = (
  criteria: FilterCriteria,
  isLoading: boolean
) => {
  if (isLoading) return;
  doAction<FilterCriteria>(AT.CUSTOMERS.FILTER_CRITERIA_UPADATED, criteria);
};

export const updateDTColumns = (columns: DT.TableColumn[]) => {
  doAction<DT.TableColumn[]>(AT.CUSTOMERS.TABLE_COLUMNS, columns);
};

export const updateColumns = () => updateDTColumns(getColumns());

/* Server Actions */

export const searchPage = (pageNumber: number) => {
  const customerState = getState();
  const page = DTHelper.getDataPage(customerState.data.pages, pageNumber);

  if (page && page.isFetching) return;

  const basePayload: DT.SearchPageBasePayload = {
    pageNumber,
    version: customerState.data.version,
  };

  MyKeysApiCustomers.searchPage(pageNumber, customerState)
    .then((res: SearchPageRes) => {
      const payload = { ...res, ...basePayload };
      doAction<SearchPageSuccessPL>(AT.CUSTOMERS.SEARCH_SUCCESS, payload);
    })
    .catch((err: ErrorDataResponse) => {
      Logger.warn([err], LogArea.Redux);
      doAction<SearchPageErrorPL>(AT.CUSTOMERS.SEARCH_ERROR, basePayload);
      doAction<FeedbackAddPL>(AT.FEEDBACK_ADD_ERROR, {
        content: [msgSearchError],
      });
    });

  doAction<SearchPageFetchPL>(AT.CUSTOMERS.SEARCH_FETCH, basePayload);
};

export const getCriteria = (keys: string[]) => {
  const customerState = getState();
  const criteria = buildCriteraList(customerState.filters, customerState.sort);
  // remove manual filters on search
  criteria.criteriaDtos = clearCriterionByType(
    criteria.criteriaDtos,
    SearchCriteriaDto.owner
  );
  // add selected items
  keys.map((k) =>
    updateCriteria(criteria.criteriaDtos, criterionNames.owner, k)
  );
  return criteria;
};

export const getTotals = (keys: string[] = []) => {
  const customerState = getState();
  const { data } = customerState;

  return getTotalsFromSelectedKeys(keys, data) as Devices.TotalsByType;
};
